import Html from "./assets/icons/html.svg";
import Css from "./assets/icons/css3.svg";
import Js from "./assets/icons/javascript.svg";
import React from "./assets/icons/react.svg";
import Ts from "./assets/icons/typescript.svg";
import Gql from "./assets/icons/graphQL.svg";

export const skillsIcons = [
  {
    img: Html,
    title: "HTML5",
  },
  {
    img: Css,
    title: "CSS3",
  },
  {
    img: Js,
    title: "Java Script",
  },
  {
    img: Ts,
    title: "Type Script",
  },
  {
    img: Gql,
    title: "GraphQL",
  },
  {
    img: React,
    title: "React",
  },
];

export const navlinks = [
  {
    name: "Home",
    link: "#home",
  },
  {
    name: "About",
    link: "#about",
  },
  {
    name: "Projects",
    link: "#projects",
  },
  {
    name: "Contact",
    link: "#contact",
  },
];
